var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_vm._t("default"),_c('div',{staticClass:"block-message"},[_vm._v(" "+_vm._s(_vm.message.message)+" ")]),_c('div',{staticClass:"message-time"},[_vm._v(_vm._s(_vm.message.senderName)+" "+_vm._s(_vm._f("formatDatetime")(_vm.message.createdOn)))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }